// extracted by mini-css-extract-plugin
export var actions = "cb_cM";
export var articleMultipleChoiceCTA = "cb_hZ";
export var body = "cb_h1";
export var bodyContainer = "cb_h0";
export var illustration = "cb_h3";
export var selected = "cb_h6";
export var subtitle = "cb_h5";
export var textContent = "cb_h4";
export var tile = "cb_h2";
export var wrapper = "cb_bF";